import React from 'react';

export const CustomerGeneralTabContent = ({
    customer,
    formatDate,
    isEditingProfile,
    profileForm,
    statusOptions,
    isSavingProfile,
    onProfileInputChange,
    onStartEditProfile,
    onCancelEditProfile,
    onSaveProfile,
}) => {
    return (
        <>
            <div className="about-section mb-5">
                <div className="mb-4 d-flex align-items-center justify-content-between">
                    <h5 className="fw-bold mb-0">Acerca de:</h5>
                    {!isEditingProfile && (
                        <button type="button" className="btn btn-sm btn-light-brand" onClick={onStartEditProfile}>
                            Editar
                        </button>
                    )}
                </div>

                {!isEditingProfile && (
                    <>
                        <p className="mb-2">{customer.description || 'Sin descripción disponible.'}</p>
                    </>
                )}

                {isEditingProfile && (
                    <div className="row g-0 align-items-center">
                        <label className="col-sm-2 text-muted" htmlFor="customer-description">Descripción:</label>
                        <div className="col-sm-10">
                            <textarea
                                id="customer-description"
                                name="description"
                                className="form-control"
                                rows={3}
                                value={profileForm.description}
                                onChange={onProfileInputChange}
                            />
                        </div>
                    </div>
                )}
            </div>

            <div className="profile-details mb-5">
                <div className="mb-4 d-flex align-items-center justify-content-between">
                    <h5 className="fw-bold mb-0">Detalles del cliente:</h5>
                    {!isEditingProfile && (
                        <button type="button" className="btn btn-sm btn-light-brand" onClick={onStartEditProfile}>
                            Editar
                        </button>
                    )}
                </div>

                {!isEditingProfile && (
                    <>
                        <div className="row g-0 mb-4">
                            <div className="col-sm-6 text-muted">Compañía:</div>
                            <div className="col-sm-6 fw-semibold">{customer.name || '-'}</div>
                        </div>
                        <div className="row g-0 mb-4">
                            <div className="col-sm-6 text-muted">Contacto:</div>
                            <div className="col-sm-6 fw-semibold">{customer.contactName || '-'}</div>
                        </div>
                        <div className="row g-0 mb-4">
                            <div className="col-sm-6 text-muted">Email:</div>
                            <div className="col-sm-6 fw-semibold">{customer.contactEmail || '-'}</div>
                        </div>
                        <div className="row g-0 mb-4">
                            <div className="col-sm-6 text-muted">Teléfono:</div>
                            <div className="col-sm-6 fw-semibold">{customer.contactPhone || '-'}</div>
                        </div>
                        <div className="row g-0 mb-4">
                            <div className="col-sm-6 text-muted">Estatus:</div>
                            <div className="col-sm-6 fw-semibold">{customer.status || '-'}</div>
                        </div>
                        <div className="row g-0">
                            <div className="col-sm-6 text-muted">Fecha de alta:</div>
                            <div className="col-sm-6 fw-semibold">{formatDate(customer.joinDate)}</div>
                        </div>
                    </>
                )}

                {isEditingProfile && (
                    <>
                        <div className="row g-0 mb-4 align-items-center">
                            <label className="col-sm-4 text-muted" htmlFor="customer-name">Compañía:</label>
                            <div className="col-sm-8">
                                <input
                                    id="customer-name"
                                    type="text"
                                    name="name"
                                    className="form-control"
                                    value={profileForm.name}
                                    onChange={onProfileInputChange}
                                />
                            </div>
                        </div>

                        <div className="row g-0 mb-4 align-items-center">
                            <label className="col-sm-4 text-muted" htmlFor="customer-contact-name">Contacto:</label>
                            <div className="col-sm-8">
                                <input
                                    id="customer-contact-name"
                                    type="text"
                                    name="contactName"
                                    className="form-control"
                                    value={profileForm.contactName}
                                    onChange={onProfileInputChange}
                                />
                            </div>
                        </div>

                        <div className="row g-0 mb-4 align-items-center">
                            <label className="col-sm-4 text-muted" htmlFor="customer-contact-email">Email:</label>
                            <div className="col-sm-8">
                                <input
                                    id="customer-contact-email"
                                    type="email"
                                    name="contactEmail"
                                    className="form-control"
                                    value={profileForm.contactEmail}
                                    onChange={onProfileInputChange}
                                />
                            </div>
                        </div>

                        <div className="row g-0 mb-4 align-items-center">
                            <label className="col-sm-4 text-muted" htmlFor="customer-contact-phone">Teléfono:</label>
                            <div className="col-sm-8">
                                <input
                                    id="customer-contact-phone"
                                    type="text"
                                    name="contactPhone"
                                    className="form-control"
                                    value={profileForm.contactPhone}
                                    onChange={onProfileInputChange}
                                />
                            </div>
                        </div>

                        <div className="row g-0 mb-4 align-items-center">
                            <label className="col-sm-4 text-muted" htmlFor="customer-status">Estatus:</label>
                            <div className="col-sm-8">
                                <select
                                    id="customer-status"
                                    name="status"
                                    className="form-select form-select-sm"
                                    value={profileForm.status}
                                    onChange={onProfileInputChange}
                                >
                                    {statusOptions.map((status) => (
                                        <option key={status.value} value={status.value}>{status.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="row g-0 mb-4 align-items-center">
                            <label className="col-sm-4 text-muted" htmlFor="customer-join-date">Fecha de alta:</label>
                            <div className="col-sm-8">
                                <input
                                    id="customer-join-date"
                                    type="date"
                                    name="joinDate"
                                    className="form-control"
                                    value={profileForm.joinDate}
                                    onChange={onProfileInputChange}
                                />
                            </div>
                        </div>

                        <div className="d-flex gap-2 justify-content-end">
                            <button
                                type="button"
                                className="btn btn-light-brand"
                                onClick={onCancelEditProfile}
                                disabled={isSavingProfile}
                            >
                                Cancelar
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={onSaveProfile}
                                disabled={isSavingProfile}
                            >
                                {isSavingProfile ? 'Guardando...' : 'Guardar'}
                            </button>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};
